import { PresentationDisplayInterface } from 'interfaces/interfaces-data';
import { RefObject } from 'react';
import { create } from 'zustand';

interface UseStudioStoreInterface {
  presentationDisplayDetailsRef: RefObject<PresentationDisplayInterface> | null;
  setPresentationDisplayDetailsRef: (
    ref: RefObject<PresentationDisplayInterface>
  ) => void;
}

export const useStudioStore = create<UseStudioStoreInterface>()((set, get) => {
  return {
    presentationDisplayDetailsRef: null,
    setPresentationDisplayDetailsRef: (ref) =>
      set({ presentationDisplayDetailsRef: ref }),
  };
});
